export const fr = {
    // Plantes
    plants: {
        default: { name: 'Plante Basique', description: 'Une plante basique qui pousse facilement.' },
        small_blue: { name: 'Petite Bleue', description: 'Une petite plante bleue délicate.' },
        pink_flower: { name: 'Fleur Rose', description: 'Une jolie fleur rose qui attire les papillons.' },
        rainbow: { name: 'Arc-en-ciel', description: 'Une plante aux couleurs de l\'arc-en-ciel.' },
        tall_purple: { name: 'Grande Violette', description: 'Une grande plante majestueuse de couleur violette.' },
        rare: { name: 'Plante Rare', description: 'Une plante rare difficile à trouver et à faire pousser.' },
        fire_red: { name: 'Flamme Rouge', description: 'Une plante ardente qui semble danser comme une flamme.' },
        legendary: { name: 'Plante Légendaire', description: 'Une plante légendaire aux propriétés mystérieuses.' },
        golden_giant: { name: 'Géante Dorée', description: 'Une plante géante aux reflets dorés très prisée.' }
    },

    // Outils
    tools: {
        auto_gardener: { name: 'Service de jardinage', description: 'Effectue un clic de jardinage sur toutes vos plantes toutes les 10 secondes' },
        pruning_shears: { name: 'Sécateur', description: 'Permet de couper une branche pour orienter la croissance' },
        fertilizer: { name: 'Engrais', description: 'Double la vitesse de croissance pendant 1 heure' },
        watering_can_upgrade: { name: 'Arrosoir Amélioré', description: 'Triple l\'effet de l\'arrosage' }
    },

    // Arrière-plans
    backgrounds: {
        background_garden: { name: 'Jardin', description: 'Un jardin verdoyant classique' },
        background_forest: { name: 'Forêt', description: 'Une forêt dense et mystérieuse' },
        background_desert: { name: 'Désert', description: 'Un désert aride et ensoleillé' },
        background_beach: { name: 'Plage', description: 'Une plage tropicale paradisiaque' },
        background_mountains: { name: 'Montagnes Alpines', description: 'Une vallée fraîche entourée de sommets enneigés' },
        background_city_garden: { name: 'Jardin Urbain', description: 'Un jardin moderne en pleine ville' },
        background_twilight: { name: 'Crépuscule Enchanté', description: 'Un ciel violet profond illuminé par des lucioles' }
    },

    // Pots
    pots: {
        pot_red: { name: 'Pot Rouge', description: 'Un joli pot rouge pour votre plante' },
        pot_blue: { name: 'Pot Bleu', description: 'Un élégant pot bleu pour votre plante' },
        pot_gold: { name: 'Pot Doré', description: 'Un luxueux pot doré pour votre plus belle plante' }
    },

    general: {
        loading: 'Chargement...'
    },

    // PlantCard
    plantCard: {
        stage: 'Étape',
        mature: 'Mature',
        progression: 'Progression',
        seedProduction: 'Production de graines',
        collectSeed: 'Récolter la graine'
    },

    // Header
    header: {
        title: 'Mon Jardin Pixel',
        myGarden: 'Mon Jardin',
        shop: 'Boutique',
        help: 'Aide',
        community: 'Communauté',
        myPublishedPlants: 'Mes Plantes Publiées',
        myAccount: 'Mon Compte',
        signOut: 'Déconnexion',
        saveCtaMobile: 'S\'inscrire'
    },
    leaveGardenModal: {
        title: 'Quitter le jardin ?',
        body: 'Tu vas perdre la progression de ton jardin si tu quittes cette page sans créer de compte.',
        cta: 'Veux-tu créer un compte gratuitement pour sauvegarder ton jardin avant de continuer ?',
        createAccount: 'Créer mon compte',
        quitAndLose: 'Quitter et tout perdre'
    },
    multiGarden: {
        headerTitle: '🌿 Mon Jardin Pixel',
        publishModalTitle: 'Publier votre jardin dans la communauté',
        publishModalBody: 'Voulez-vous partager tout votre jardin avec la communauté ? La publication nécessite au moins une plante mature.',
        loginToPublish: 'Se connecter pour publier',
        publishButton: 'Publier',
        publishButtonLoading: 'Publication...',
        cancelButton: 'Annuler',
        publishPreviewLabel: 'Aperçu de votre jardin partagé',
        destroyModalTitle: 'Détruire la plante',
        destroyModalBody: 'Êtes-vous sûr de vouloir détruire cette plante ? Cette action est irréversible.',
        destroyButton: 'Détruire',
        waterNeedPlant: 'Plante une graine pour utiliser les outils.',
        waterReadyPrefix: 'Ton eau sera rechargée dans',
        waterNoWater: "Tu n'as plus assez d'eau pour arroser.",
        gardenerBadgeTitle: 'Service de jardinage',
        gardenerPulse: 'Un tour de jardinage vient de passer…',
        gardenerIdleFallback: 'Jardine toutes les 10s',
        toolHints: {
            sun: 'Soleil : clique sur une plante pour accélérer sa croissance.',
            water: "Eau : clique sur une plante pour lui donner un gros boost de croissance (consomme de l'eau)",
            hand: 'Main : clique sur une plante pour l\'arracher et récupérer des graines.',
            pruner: 'Sécateur : clique sur une plante pour couper ses branches.',
            camera: 'Appareil photo : prends un snapshot de ton jardin pour le publier.',
            zoomIn: 'Zoom + : rapproche-toi de ton jardin.',
            zoomOut: 'Zoom - : éloigne-toi de ton jardin.'
        }
    },
    landing: {
        heroTitle: 'Mon Jardin Pixel',
        heroSubtitle: 'Cultivez votre jardin virtuel en pixel art, faites pousser des plantes uniques et partagez vos créations avec la communauté !',
        heroCta: 'Essayer gratuitement',
        topPlantsTitle: '🌟 Plantes les plus aimées',
        topPlantsSubtitle: 'Découvrez les créations favorites de la communauté',
        topPlantsEmpty: 'Soyez le premier à partager votre plante !',
        viewGallery: 'Voir toute la galerie',
        howItWorksTitle: 'Comment ça marche ?',
        plantSeedTitle: 'Plantez une graine',
        plantSeedText: 'Glissez-déposez votre graine dans la terre pour commencer votre aventure',
        growTitle: 'Arrosez et cultivez',
        growText: "Cliquez sur l'eau et le soleil pour faire grandir votre plante unique",
        shareTitle: 'Partagez',
        shareText: 'Exposez vos plus belles plantes dans la galerie communautaire',
        premiumTitle: 'Fonctionnalités Premium',
        autoGardenerTitle: 'Jardinier Automatique',
        autoGardenerText: "Laissez votre jardinier virtuel s'occuper de vos plantes pendant que vous êtes absent",
        autoGardenerPrice: 'À partir de 1€/mois',
        shopTitle: "Boutique d'outils",
        shopText: 'Débloquez des outils spéciaux, des graines rares et des cosmétiques uniques',
        shopPrice: 'Achetez avec vos graines',
        ctaTitle: 'Prêt à cultiver votre jardin ?',
        ctaSubtitle: 'Commencez gratuitement dès maintenant, aucune carte bancaire requise',
        ctaButton: 'Commencer maintenant',
        stageLabel: 'Stade'
    },
    shop: {
        title: 'Boutique',
        subtitle: 'Choisissez un marchand pour découvrir ses produits',
        autoGrowthLabel: 'Croissance automatique :',
        perMonth: '/mois',
        popular: 'Populaire',
        subscribe: 'S\'abonner',
        autoGrowth: 'Croissance automatique',
        plantSlots: 'Emplacements de plantes',
        access: 'Accès',
        basicAccess: 'De base',
        advancedTools: 'Outils avancés',
        allTools: 'Tous les outils',
        clicksPerSecond: 'clics/seconde',
        plantSlotsCount: 'emplacements',
        startFreeTrial: 'Essai gratuit de 7 jours',
        cancelAnytime: 'Annulez à tout moment',
        price: 'Prix',
        effect: 'Effet',
        duration: 'Durée',
        permanent: 'Permanent',
        hours: 'heures',
        unlimited: 'Illimité',
        merchants: {
            tools: {
                name: 'Marchand d\'Outils',
                description: 'Outils pour améliorer votre jardinage'
            },
            seeds: {
                name: 'Marchand de Graines',
                description: 'Graines rares et légendaires'
            },
            cosmetics: {
                name: 'Marchand de Cosmétiques',
                description: 'Personnalisez votre jardin'
            }
        },
        subscriptionsTitle: 'Abonnements Jardinier Automatique',
        plans: {
            basic: {
                name: 'Basique',
                price: '1€',
                description: 'Jardinier automatique débutant : 1 clic toutes les 5 secondes sur chaque plante.',
                clicks: '1 clic / 5 s',
                features: [
                    'Jardinier lent (1 clic / 5 s)',
                    '3 plantes prises en charge'
                ]
            },
            standard: {
                name: 'Standard',
                price: '3€',
                description: 'Jardinier entraîné : 1 clic toutes les 2 secondes pour dynamiser la croissance.',
                clicks: '1 clic / 2 s',
                features: [
                    'Jardinier rapide (1 clic / 2 s)',
                    '5 plantes prises en charge'
                ]
            },
            premium: {
                name: 'Premium',
                price: '5€',
                description: 'Jardinier expert : 1 clic par seconde sur toutes vos plantes, même lorsque vous êtes absent.',
                clicks: '1 clic / seconde',
                features: [
                    'Jardinier éclair (1 clic / s)',
                    '10 plantes prises en charge'
                ]
            }
        },
        tabs: {
            tools: 'Outils',
            backgrounds: 'Arrière-plans',
            pots: 'Pots',
            subscriptions: 'Abonnements',
            cosmetics: 'Cosmétiques'
        },
        items: {
            tools: {
                auto_gardener: {
                    name: 'Service de jardinage',
                    description: 'Effectue un clic de jardinage sur toutes vos plantes toutes les 10 secondes'
                },
                pruning_shears: {
                    name: 'Sécateur',
                    description: 'Permet de couper une branche pour orienter la croissance'
                },
                fertilizer: {
                    name: 'Engrais',
                    description: 'Double la vitesse de croissance pendant 1 heure'
                },
                watering_can_upgrade: {
                    name: 'Arrosoir Amélioré',
                    description: 'Triple l\'effet de l\'arrosage sur vos plantes'
                }
            },
            backgrounds: {
                garden: {
                    name: 'Jardin Classique',
                    description: 'Un jardin verdoyant classique pour cultiver vos plantes'
                },
                forest: {
                    name: 'Forêt Enchantée',
                    description: 'Une forêt mystérieuse pleine de magie et de mystères'
                },
                desert: {
                    name: 'Désert Aride',
                    description: 'Un paysage désertique chaud et ensoleillé'
                },
                beach: {
                    name: 'Plage Paradisiaque',
                    description: 'Une plage de sable fin avec une mer cristalline'
                },
                mountains: {
                    name: 'Sommets Alpins',
                    description: 'Une vue panoramique sur des montagnes enneigées'
                },
                mountain: {
                    name: 'Montagne Majestueuse',
                    description: 'Des sommets enneigés à perte de vue'
                },
                city_garden: {
                    name: 'Jardin Urbain',
                    description: 'Un espace vert au cœur de la ville'
                },
                twilight: {
                    name: 'Crépuscule Enchanté',
                    description: 'Un ciel violet illuminé par les étoiles'
                }
            },
            pots: {
                pot_red: {
                    name: 'Pot Rouge',
                    description: 'Un joli pot rouge pour mettre en valeur vos plantes'
                },
                pot_blue: {
                    name: 'Pot Bleu',
                    description: 'Un élégant pot bleu pour vos plus belles plantes'
                },
                pot_gold: {
                    name: 'Pot Doré',
                    description: 'Un luxueux pot doré pour vos plantes les plus rares'
                }
            }
        },
        purchaseButton: 'Acheter',
        ownedLabel: 'Déjà possédé',
        selectLabel: 'Sélectionner'
    },
    community: {
        title: 'Jardins de la Communauté',
        subtitle: 'Découvrez les plus beaux jardins créés par la communauté',
        successTitle: 'Jardin publié !',
        successDescription: 'Votre jardin est maintenant visible dans la communauté',
        emptyTitle: "Aucun jardin n'a encore été publié",
        emptySubtitle: 'Soyez le premier à partager votre jardin !',
        cardOwnerUnknown: 'Anonyme',
        cardPlantSingular: 'plante dans le jardin',
        cardPlantPlural: 'plantes dans le jardin',
        likeButtonLoggedIn: 'Liker ce jardin',
        likeButtonLoggedOut: 'Connectez-vous pour liker'
    },
    published: {
        title: 'Mes Plantes Publiées',
        subtitle: 'Gérez vos jardins partagés dans la communauté',
        emptyTitle: "Vous n'avez pas encore publié de jardins",
        emptyCta: 'Retour au jardin',
        stageLabel: 'Stade',
        likeLabel: 'Likes',
        publishedLabel: 'Publié le',

        // Boutons
        sacrificeButton: 'Sacrifier le jardin',
        deleteButton: 'Supprimer',
        deleteConfirm: 'Supprimer',
        cancel: 'Annuler',

        // Modale de suppression
        deleteModalTitle: 'Supprimer la plante',
        deleteModalBody: 'Êtes-vous sûr de vouloir supprimer cette plante ? Cette action est irréversible et vous ne recevrez aucune graine.',
        deleting: 'Suppression...',
        deleteError: 'Erreur lors de la suppression',

        // Modale de sacrifice
        sacrificeModalTitle: 'Sacrifier le jardin',
        sacrificeReward: 'Sacrifier ce jardin vous rapportera',
        sacrificeRewardIntro: 'Sacrifier ce jardin vous rapportera',
        sacrificeCalc: 'Calcul :',
        sacrificing: 'Sacrifice...',
        sacrificeError: 'Erreur lors du sacrifice',
        confirmSacrifice: 'Confirmer le sacrifice',
        selectGardenToSacrifice: 'Sélectionnez un jardin à sacrifier.',

        // Termes pour le calcul des récompenses
        seedSingular: 'graine',
        seedPlural: 'graines',
        matureSingular: 'plante mature',
        maturePlural: 'plantes matures',
        likeSingular: 'like',
        likePlural: 'likes',
        rewardCalcPrefix: 'Calcul :',
        selectGardenPrompt: 'Sélectionnez un jardin à sacrifier.'
    },
    account: {
        title: 'Mon Compte',
        personalInfoTitle: 'Informations personnelles',
        usernameLabel: "Nom d'utilisateur",
        usernameFallback: 'Non défini',
        emailLabel: 'Email',
        editProfile: 'Modifier mon profil',
        subscriptionTitle: 'Abonnement',
        subscriptionActive: 'Abonnement actif',
        subscriptionRenew: 'Renouvellement le',
        manageSubscription: 'Gérer mon abonnement',
        noSubscription: "Vous n'avez pas d'abonnement actif. Souscrivez à un abonnement pour bénéficier du jardinier automatique !",
        viewPlans: 'Voir les abonnements',
        dangerZoneTitle: 'Zone dangereuse',
        signOut: 'Se déconnecter'
    },
    seedSelector: {
        noSeeds: "Vous n'avez pas de graines.",
        growPlantToGetSeeds: 'Faites pousser une plante pour en obtenir !',
        defaultSeedName: 'Graine',
        plant: 'Planter',
        noPlantsYet: 'Aucune plante. Sélectionnez une graine et cliquez sur le canvas pour planter !'
    },
    saveProgressPrompt: {
        title: 'Sauvegarder votre progression ?',
        progressMade: 'Vous avez fait des progrès dans votre jardin !',
        createAccountToSave: 'Créez un compte gratuit pour sauvegarder votre progression et y accéder depuis n\'importe où.',
        yourProgress: 'Votre progression :',
        growingPlant: 'Une plante en cours de croissance',
        seed: 'graine',
        seed_plural: 'graines',
        createAccountFree: 'Créer un compte (gratuit)',
        continueWithoutSaving: 'Continuer sans sauvegarder'
    },
    footer: {
        brand: {
            title: 'Mon Jardin Pixel',
            description: 'Cultivez votre jardin virtuel en pixel art et partagez vos créations avec la communauté.'
        },
        usefulLinks: {
            title: 'Liens utiles',
            help: 'Aide & FAQ',
            community: 'Communauté',
            shop: 'Boutique'
        },
        legal: {
            title: 'Légal',
            terms: "Conditions d'utilisation",
            privacy: 'Politique de confidentialité'
        },
        copyright: 'Mon Jardin Pixel. Tous droits réservés.'
    },
    help: {
        title: 'Aide & FAQ',
        subtitle: 'Tout ce que vous devez savoir pour cultiver votre jardin',
        gameMechanics: {
            title: 'Mécaniques de jeu',
            plant: {
                title: 'Planter',
                description: 'Glissez une graine dans la terre pour commencer à cultiver votre plante unique.'
            },
            water: {
                title: 'Arroser',
                description: 'L\'arrosage donne un bonus de croissance à votre plante.'
            },
            sun: {
                title: 'Soleil',
                description: 'Chaque clic sur le soleil fait progresser la croissance de votre plante.'
            },
            prune: {
                title: 'Tailler',
                description: 'Utilisez le sécateur pour orienter la croissance de votre plante.'
            },
            shop: {
                title: 'Boutique',
                description: 'Achetez des outils, graines rares et cosmétiques avec vos graines.'
            },
            community: {
                title: 'Communauté',
                description: 'Partagez vos plantes et likez celles des autres jardiniers.'
            }
        },
        faq: {
            title: 'Questions fréquentes',
            faqs: {
                howToPlant: {
                    question: 'Comment planter une graine ?',
                    answer: 'Glissez-déposez une graine depuis votre inventaire vers la zone de terre, ou cliquez sur le bouton "Planter une graine".'
                },
                howToGrow: {
                    question: 'Comment faire pousser ma plante ?',
                    answer: 'Cliquez sur le soleil pour faire grandir votre plante et utilisez la goutte d\'eau dès que votre réserve est disponible (le bouton affiche le temps restant quand le réservoir est vide).'
                },
                howToGetSeeds: {
                    question: 'Comment obtenir des graines ?',
                    answer: 'Chaque plante mature prépare une graine avec le temps. Le service de jardinage collecte automatiquement celles prêtes, même si vous êtes sur une autre page. Vous pouvez aussi acheter des graines spécifiques dans la boutique.'
                },
                seedPurpose: {
                    question: 'À quoi servent les graines ?',
                    answer: 'Les graines servent de monnaie dans le jeu. Vous pouvez les utiliser pour acheter des outils, des graines rares et des cosmétiques.'
                },
                autoGardener: {
                    question: 'Qu\'est-ce que le jardinier automatique ?',
                    answer: 'Il existe deux options : un service permanent à acheter avec des graines (1 clic toutes les 10 s sur toutes vos plantes) et des abonnements mensuels (Basique 1 clic/5 s, Standard 1 clic/2 s, Premium 1 clic/s). Ils continuent de travailler et de récolter quand vous n\'êtes pas dans le jardin.'
                },
                howToolsWork: {
                    question: 'Comment fonctionnent les outils ?',
                    answer: 'Le sécateur, l\'engrais et l\'arrosoir amélioré doivent être achetés dans la boutique d\'outils. Le sécateur débloque la possibilité de tailler des branches. L\'engrais s\'active immédiatement après l\'achat (bonus x2 pendant 1 heure puis disponible à nouveau). L\'arrosoir amélioré multiplie à vie l\'efficacité de chaque arrosage.'
                },
                howToShare: {
                    question: 'Comment partager ma plante ?',
                    answer: 'Une fois votre plante mature, cliquez sur "Publier dans la communauté" pour la partager dans la galerie publique.'
                },
                prunerPurpose: {
                    question: 'À quoi sert le sécateur ?',
                    answer: 'Après l\'avoir acheté dans la boutique d\'outils, il permet de couper des branches pour orienter la croissance de votre plante.'
                }
            }
        }
    },
    terms: {
        title: 'Conditions Générales d\'Utilisation',
        localeCode: 'fr-FR',
        acceptance: {
            title: '1. Acceptation des conditions',
            content: 'En accédant et en utilisant Mon Jardin Pixel, vous acceptez d\'être lié par ces conditions générales d\'utilisation. Si vous n\'acceptez pas ces conditions, veuillez ne pas utiliser notre service.'
        },
        serviceDescription: {
            title: '2. Description du service',
            content: 'Mon Jardin Pixel est un jeu de type idle clicker permettant aux utilisateurs de cultiver des plantes virtuelles en pixel art. Le service est accessible via navigateur web et appareils mobiles.'
        },
        userAccount: {
            title: '3. Compte utilisateur',
            content: 'Pour accéder à certaines fonctionnalités, vous devez créer un compte. Vous êtes responsable de la confidentialité de vos identifiants et de toutes les activités effectuées sous votre compte.'
        },
        subscriptions: {
            title: '4. Abonnements et paiements',
            content: 'Les abonnements au jardinier automatique sont facturés mensuellement via Stripe. Vous pouvez annuler votre abonnement à tout moment. Les paiements sont non remboursables sauf disposition légale contraire.'
        },
        intellectualProperty: {
            title: '5. Propriété intellectuelle',
            content: 'Tous les contenus du jeu, y compris les graphismes, le code et les mécaniques de jeu, sont la propriété de Mon Jardin Pixel. Les plantes créées par les utilisateurs restent leur propriété.'
        },
        userConduct: {
            title: '6. Conduite de l\'utilisateur',
            content: 'Vous vous engagez à ne pas utiliser le service de manière abusive, illégale ou contraire à l\'éthique. Nous nous réservons le droit de suspendre ou supprimer tout compte en cas de violation de ces conditions.'
        },
        liability: {
            title: '7. Limitation de responsabilité',
            content: 'Mon Jardin Pixel est fourni "tel quel" sans garantie d\'aucune sorte. Nous ne sommes pas responsables des dommages directs ou indirects résultant de l\'utilisation du service.'
        },
        modifications: {
            title: '8. Modifications',
            content: 'Nous nous réservons le droit de modifier ces conditions à tout moment. Les modifications prendront effet dès leur publication sur le site.'
        },
        contact: {
            title: '9. Contact',
            content: 'Pour toute question concernant ces conditions, veuillez nous contacter à l\'adresse : contact@monjardinpixel.com'
        },
        lastUpdated: 'Dernière mise à jour : {{date}}'
    },
    privacy: {
        title: 'Politique de Confidentialité',
        localeCode: 'fr-FR',
        dataCollection: {
            title: '1. Collecte des données',
            intro: 'Nous collectons les informations suivantes lors de votre utilisation de Mon Jardin Pixel :',
            email: 'Adresse email et nom d\'utilisateur lors de l\'inscription',
            gameData: 'Données de jeu (plantes, graines, progression)',
            payment: 'Informations de paiement (traitées de manière sécurisée par Stripe)',
            analytics: 'Données d\'utilisation et statistiques anonymisées'
        },
        dataUsage: {
            title: '2. Utilisation des données',
            intro: 'Vos données sont utilisées pour :',
            provideService: 'Fournir et améliorer nos services',
            manageAccount: 'Gérer votre compte et vos abonnements',
            communication: 'Communiquer avec vous concernant le service',
            analytics: 'Analyser l\'utilisation du jeu pour améliorer l\'expérience'
        },
        dataSharing: {
            title: '3. Partage des données',
            intro: 'Nous ne vendons jamais vos données personnelles. Vos informations peuvent être partagées uniquement avec :',
            stripe: 'Stripe pour le traitement des paiements',
            supabase: 'Supabase pour l\'hébergement sécurisé des données',
            legal: 'Les autorités légales si requis par la loi'
        },
        security: {
            title: '4. Sécurité',
            content: 'Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles pour protéger vos données contre tout accès non autorisé, modification, divulgation ou destruction.'
        },
        cookies: {
            title: '5. Cookies',
            content: 'Nous utilisons des cookies essentiels pour le fonctionnement du jeu, notamment pour maintenir votre session de connexion et sauvegarder vos préférences.'
        },
        gdpr: {
            title: '6. Vos droits (RGPD)',
            intro: 'Conformément au RGPD, vous disposez des droits suivants :',
            access: 'Droit d\'accès à vos données personnelles',
            rectification: 'Droit de rectification de vos données',
            erasure: 'Droit à l\'effacement de vos données',
            portability: 'Droit à la portabilité de vos données',
            objection: 'Droit d\'opposition au traitement de vos données',
            contact: 'Pour exercer ces droits, contactez-nous à : privacy@monjardinpixel.com'
        },
        dataRetention: {
            title: '7. Conservation des données',
            content: 'Nous conservons vos données aussi longtemps que votre compte est actif. Si vous supprimez votre compte, vos données seront effacées dans un délai de 30 jours.'
        },
        modifications: {
            title: '8. Modifications',
            content: 'Cette politique de confidentialité peut être mise à jour. Nous vous informerons de tout changement significatif par email ou via une notification dans le jeu.'
        },
        contact: {
            title: '9. Contact',
            content: 'Pour toute question concernant cette politique de confidentialité, contactez-nous à : privacy@monjardinpixel.com'
        },
        lastUpdated: 'Dernière mise à jour : {{date}}'
    },
    seedInventory: {
        title: 'Graines',
        availableAllSeeds: 'Disponibles (toutes graines):',
        cancel: 'Annuler'
    },
    plantList: {
        title: 'Plantes dans le jardin',
        noPlants: 'Aucune plante. Sélectionnez une graine et cliquez sur le canvas pour planter !'
    },
    plantCard: {
        stage: 'Stade',
        mature: 'Mature',
        progression: 'Progression',
        seedProduction: 'Production de graine',
        collectSeed: 'Collecter la graine'
    },
    waterLevelGauge: {
        waterLevel: "Niveau d'eau"
    },
    modeSelector: {
        sun: 'Soleil',
        water: 'Eau'
    },
    freeSeedClaim: {
        freeSeed: 'Graine Gratuite',
        description: 'Une graine de Plante Basique offerte toutes les 13 heures',
        claimed: 'Graine récupérée avec succès !',
        free: 'GRATUIT',
        claim: 'Récupérer',
        nextSeedIn: 'Prochaine graine dans :',
        unavailable: 'Indisponible'
    },
    profile: {
        title: 'Mon Profil Public',
        updateSuccess: 'Profil mis à jour avec succès !',
        updateError: 'Erreur lors de la mise à jour du profil',
        usernameLabel: "Nom d'utilisateur",
        usernamePlaceholder: 'Votre pseudo',
        bioLabel: 'Biographie',
        bioPlaceholder: 'Parlez-nous de vous...',
        characters: 'caractères',
        avatarUrlLabel: "URL de l'avatar",
        saveButton: 'Enregistrer les modifications'
    },
    auth: {
        usernameLabel: "Nom d'utilisateur",
        usernamePlaceholder: 'Votre pseudo',
        emailLabel: 'Email',
        emailPlaceholder: 'votre@email.com',
        resetEmailSent: 'Email de réinitialisation envoyé ! Vérifiez votre boîte mail.',
        signIn: 'Connexion',
        signUp: 'Inscription',
        saveProgress: 'Sauvegarder votre progression',
        resetPassword: 'Réinitialiser le mot de passe',
        passwordLabel: 'Mot de passe',
        passwordPlaceholder: '••••••••',
        signInButton: 'Se connecter',
        signUpButton: "S'inscrire",
        sendLinkButton: 'Envoyer le lien',
        forgotPassword: 'Mot de passe oublié ?',
        noAccount: 'Pas encore de compte ?',
        hasAccount: 'Déjà un compte ?',
        backToSignIn: 'Retour à la connexion'
    },
    inlineAuth: {
        progress: {
            title: 'Votre progression',
            growingPlant: 'Une plante en cours de croissance',
            seedSingular: 'graine',
            seedPlural: 'graines',
            footer: 'Créez un compte gratuit pour ne jamais perdre votre progression !'
        },
        messages: {
            accountCreated: 'Compte créé ! Vérifiez votre email pour confirmer votre inscription.'
        },
        errors: {
            usernameRequired: "Le nom d'utilisateur est requis",
            generic: 'Une erreur est survenue'
        }
    },
    myGarden: {
        mustBeLoggedInToPublish: 'Vous devez être connecté pour publier votre plante.',
        publishPlantTitle: 'Publier votre plante',
        publishPlantDescription: 'Votre plante sera visible dans la galerie communautaire. Les autres joueurs pourront la liker !'
    },
    merchant: {
        confirmButton: 'Confirmer',
        backButton: 'Retour',
        toolsMerchant: "Marchand d'Outils",
        seedsMerchant: 'Marchand de Graines',
        cosmeticsMerchant: 'Marchand de Cosmétiques',
        defaultMerchant: 'Marchand',
        basicSeedsLabel: 'Vos graines basiques:',
        noItemsAvailable: 'Aucun article disponible pour le moment',
        owned: 'Possédé',
        active: 'Actif',
        alreadyOwned: 'Déjà possédé',
        notEnoughSeeds: 'Pas assez de graines',
        buyButton: 'Acheter',
        confirmPurchaseTitle: "Confirmer l'achat",
        activeEffect: 'Effet actif... revenez plus tard pour en racheter',
        clickInfo: 'clic(s) toutes les'
    },
    gameConfig: {
        plants: {
            default: 'Plante Basique',
            small_blue: 'Petite Bleue',
            pink_flower: 'Fleur Rose',
            rainbow: 'Arc-en-ciel',
            tall_purple: 'Grande Violette',
            rare: 'Plante Rare',
            fire_red: 'Flamme Rouge',
            legendary: 'Plante Légendaire',
            golden_giant: 'Géante Dorée'
        },
        tools: {
            auto_gardener: {
                name: 'Service de jardinage',
                description: 'Effectue un clic de jardinage sur toutes vos plantes toutes les 10 secondes'
            },
            pruning_shears: {
                name: 'Sécateur',
                description: 'Permet de couper une branche pour orienter la croissance'
            },
            fertilizer: {
                name: 'Engrais',
                description: 'Double la vitesse de croissance pendant 1 heure'
            },
            watering_can_upgrade: {
                name: 'Arrosoir Amélioré',
                description: 'Triple l\'effet de l\'arrosage'
            }
        },
        seeds: {
            small_blue_seed: {
                name: 'Graine Petite Bleue',
                description: 'Une petite plante bleue compacte'
            },
            pink_flower_seed: {
                name: 'Graine Fleur Rose',
                description: 'Une plante aux fleurs roses éclatantes'
            },
            rainbow_seed: {
                name: 'Graine Arc-en-ciel',
                description: 'Une plante multicolore fascinante'
            },
            tall_purple_seed: {
                name: 'Graine Grande Violette',
                description: 'Une grande plante violette majestueuse'
            },
            fire_red_seed: {
                name: 'Graine Flamme Rouge',
                description: 'Une plante rouge flamboyante'
            },
            rare_seed: {
                name: 'Graine Rare',
                description: 'Une graine de plante rare'
            },
            legendary_seed: {
                name: 'Graine Légendaire',
                description: 'Une graine de plante légendaire'
            },
            golden_giant_seed: {
                name: 'Graine Géante Dorée',
                description: 'La plus grande et majestueuse des plantes'
            }
        },
        cosmetics: {
            pot_red: {
                name: 'Pot Rouge',
                description: 'Un joli pot rouge pour votre plante'
            },
            pot_blue: {
                name: 'Pot Bleu',
                description: 'Un joli pot bleu pour votre plante'
            },
            background_garden: {
                name: 'Jardin',
                description: 'Un jardin verdoyant classique'
            },
            background_forest: {
                name: 'Forêt',
                description: 'Une forêt dense et mystérieuse'
            },
            background_desert: {
                name: 'Désert',
                description: 'Un désert aride et ensoleillé'
            },
            background_beach: {
                name: 'Plage',
                description: 'Une plage tropicale paradisiaque'
            },
            background_mountains: {
                name: 'Montagnes Alpines',
                description: 'Une vallée fraîche entourée de sommets enneigés'
            },
            background_city_garden: {
                name: 'Jardin Urbain',
                description: 'Un jardin moderne en pleine ville'
            },
            background_twilight: {
                name: 'Crépuscule Enchanté',
                description: 'Un ciel violet profond illuminé par des lucioles'
            }
        },
        subscriptions: {
            basic: 'Jardinier Basique',
            standard: 'Jardinier Standard',
            premium: 'Jardinier Premium'
        }
    },
    herbarium: {
        title: 'Herbier',
        viewButton: 'Voir',
        modalTitle: 'Herbier',
        progressLabel: 'Espèces découvertes',
        emptyStateTitle: 'Aucune plante découverte',
        emptyStateBody: 'Fais pousser une plante pour révéler son apparence ici.',
        unknownName: '???',
        unknownDescription: 'Cultive cette plante pour dévoiler son visuel.',
        discoveredOn: 'Découvert le'
    }
};